'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = OkButton;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _beeButton = require('bee-button');

var _beeButton2 = _interopRequireDefault(_beeButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function OkButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      okDisabled = _ref.okDisabled,
      onOk = _ref.onOk;

  var className = prefixCls + '-btn-ok';
  // if (okDisabled) {
  //   className += ` ${prefixCls}-ok-btn-disabled`;
  // }
  return _react2["default"].createElement(
    _beeButton2["default"],
    {
      className: className,
      size: 'sm', colors: 'primary',
      disabled: okDisabled,
      onClick: okDisabled ? null : onOk
    },
    locale.ok
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-datepicker/build/rc-calendar/calendar/OkButton.js
// module id = 425
// module chunks = 0